/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The calendar platform to connect to. Either 'google' for Google Calendar or 'microsoft' for Microsoft Outlook/365.
 */
export type ListRawCalendarsRequestBodyCalendarPlatform =
  (typeof ListRawCalendarsRequestBodyCalendarPlatform)[keyof typeof ListRawCalendarsRequestBodyCalendarPlatform]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListRawCalendarsRequestBodyCalendarPlatform = {
  google: "google",
  microsoft: "microsoft"
} as const
